import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

type LanguageSelectorProps = {
    lang: string | null;
    setLang: React.Dispatch<React.SetStateAction<null | string>>;
};

enum LangCode {
    ar = 'ar',
    en = 'en'
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ lang, setLang }) => {
    const [t, i18n] = useTranslation('common');
    const [selectedLang, setSelectedLang] = useState<string | null>(lang);

    const updateDirection = (language: string | null) => {
        const body = document.body;
        if (body) {
            body.dir = language === LangCode.ar ? 'rtl' : 'ltr';
        }
    };

    const onLanguageChange = (value: string) => {
        setSelectedLang(value);
        setLang(value);
        localStorage.setItem('language', value);
        updateDirection(value);
    };

    useEffect(() => {
        if (!lang) {
            localStorage.setItem('language', LangCode.en);
            setSelectedLang(LangCode.en);
            return;
        }
        localStorage.setItem('language', lang);
        i18n.changeLanguage(lang);
        updateDirection(lang);
        setSelectedLang(lang);
    }, [lang, i18n]);

    return (
        <Select
            showSearch
            optionFilterProp="label"
            placeholder={t('select-language')}
            options={[
                { value: LangCode.en, label: t('english') },
                { value: LangCode.ar, label: t('arabic') },
            ]}
            onChange={onLanguageChange}
            value={selectedLang}
        />
    );
};

export default LanguageSelector;
